module.exports = __webpack_public_path__ + "media/ubud/goa_gajah-94eda6b7.jpg";